"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.channel = exports.GLOBAL_CHANNEL_SYMBOL = void 0;
var AJS = _interopRequireWildcard(require("xajs"));
var _postmate = require("./helper/postmate");
var _detector = require("./helper/detector");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var _AJS$functional$helpe = AJS.functional.helper.PS,
  Puber = _AJS$functional$helpe.Puber,
  Suber = _AJS$functional$helpe.Suber;
var GLOBAL_CHANNEL_SYMBOL = '@@one-portal/channel';
exports.GLOBAL_CHANNEL_SYMBOL = GLOBAL_CHANNEL_SYMBOL;
var uuid = 0;
var BROADCAST_FROM_IFRAME = 'broadcast-request-from-iframe';
var BROADCAST_FROM_SAME_CONTEXT = 'broadcast-request-frome-samecontext';
var Channel = function Channel() {
  var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : GLOBAL_CHANNEL_SYMBOL;
  var _globalSuber = new Suber(name, {});
  var _globalPuber = new Puber(name, {});

  // handshakes
  var handshakes = [];

  // iframe child listeners
  var iframeChildContextListeners = {};

  // schedule queue
  var scheduleQueue = [];

  // child schedule queue
  var childScheduleQueue = [];

  // iframe context child
  var handshake = new _postmate.Postmate.Model({});
  handshake.sendHandshakeReply();
  var NOOP = function NOOP() {
    return void 0;
  };

  // 总线订阅其他发布者消息
  var __subscribe = function __subscribe(msg) {
    var handler = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : NOOP;
    var _puber = new Puber(++uuid, {});
    _puber.addSuber(_globalSuber);
    _globalSuber.rss(_puber, [{
      msg: msg,
      handler: handler
    }]);
    return {
      send: function send(message) {
        var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        _puber.pub(message, payload);
      }
    };
  };

  // 往总线里发送消息
  var __postMessage = function __postMessage(msg) {
    var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    _globalPuber.pub(msg, payload);
  };
  return {
    // iframe 需要主动调用 handshake 和父执行环境握手
    handshake: function handshake() {
      var opt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      if (opt.name && typeof opt.name === 'string') {
        new _postmate.Postmate(opt).then(function (child) {
          channel.send('postmate-handshake', {
            child: child
          });
        });
        return function () {
          // destroy first
          var current = handshakes.filter(function (child) {
            return child.frame.name === opt.name;
          })[0];
          current && current.destroy && current.destroy();

          // reset handshakes
          handshakes = handshakes.filter(function (child) {
            return child.frame.name !== opt.name;
          });
        };
      } else {
        throw new Error('channel.handshake must provide a name, see https://github.com/dollarshaveclub/postmate');
      }
    },
    // setup
    setup: function setup() {
      // schedule callback task
      var schedule = function schedule(_ref) {
        var callbackId = _ref.callbackId,
          task = _ref.task,
          origin = _ref.origin;
        // sync
        scheduleQueue.forEach(function (queue) {
          // every single callbackId in every single origin execute once
          if (callbackId === queue.callbackId && origin === queue.origin) {
            clearTimeout(queue.nextTick);
          }
        });
        scheduleQueue.push({
          callbackId: callbackId,
          origin: origin,
          nextTick: setTimeout(task)
        });
      };
      var handshakeResolver = function handshakeResolver(hs, payload) {
        return function (model) {
          if (model) {
            var callbackId = model.callbackId;
            var task = function task() {
              // 请求执行 callback
              hs.frame.contentWindow.postMessage({
                type: '@@cb.request.callback',
                callbackId: callbackId,
                payload: payload
              }, hs.childOrigin);
            };
            schedule({
              task: task,
              callbackId: callbackId,
              origin: hs.childOrigin
            });
          }
        };
      };
      channel.on(BROADCAST_FROM_SAME_CONTEXT, function (_ref2) {
        var message = _ref2.message,
          payload = _ref2.payload;
        // forward to same-context
        channel.send(message, payload);

        // forward to iframe-context
        handshakes.forEach(function (hs) {
          hs.get(message).then(handshakeResolver(hs, payload));
        });
      });

      // push child handler into global schedule
      var scheduleChildHandler = function scheduleChildHandler(_ref3) {
        var origin = _ref3.origin,
          task = _ref3.task,
          uuid = _ref3.uuid,
          callbackId = _ref3.callbackId;
        childScheduleQueue.forEach(function (queue) {
          if (callbackId === queue.callbackId && uuid === queue.uuid && origin === queue.origin) {
            clearTimeout(queue.nextTick);
          }
        });
        childScheduleQueue.push({
          origin: origin,
          nextTick: setTimeout(task),
          uuid: uuid,
          callbackId: callbackId
        });
      };

      // when postmate handshake
      channel.on('postmate-handshake', function (_ref4) {
        var child = _ref4.child;
        var _loop = function _loop(_name) {
          var listeners = iframeChildContextListeners[_name];
          listeners.forEach(function (_ref6) {
            var handler = _ref6.handler,
              uuid = _ref6.uuid;
            var callbackId = 0;
            child.on(_name, function (payload) {
              return scheduleChildHandler({
                origin: child.childOrigin,
                task: function task() {
                  return handler(payload);
                },
                uuid: uuid,
                callbackId: ++callbackId
              });
            });
          });
        };
        // get listeners
        for (var _name in iframeChildContextListeners) {
          _loop(_name);
        }

        // save handshake
        handshakes.push(child);
        child.on(BROADCAST_FROM_IFRAME, function (_ref5) {
          var message = _ref5.message,
            payload = _ref5.payload;
          // forward to iframe-context
          handshakes.forEach(function (hs) {
            hs.get(message).then(handshakeResolver(hs, payload));
          });

          // forward to same-context
          channel.send(message, payload);
        });
      });
    },
    // 监听总线上的消息
    on: function on(msg) {
      var handler = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : NOOP;
      if ((0, _detector.is)('iframe') && !_detector.isContainer) {
        handshake.model[msg] = function () {
          return handler;
        };

        // clear
        return function () {
          delete handshake.model[msg];
        };
      } else {
        // in same context
        var __uuid = ++uuid;
        var _suber = new Suber(__uuid, {});
        _globalPuber.addSuber(_suber);
        _suber.rss(_globalPuber, [{
          msg: msg,
          handler: handler
        }]);

        // if from iframe child context
        if (!iframeChildContextListeners[msg]) {
          iframeChildContextListeners[msg] = [];
        }
        iframeChildContextListeners[msg].push({
          uuid: __uuid,
          handler: handler
        });

        // clear
        return function () {
          delete _globalPuber._subers[__uuid];
          iframeChildContextListeners[msg] = iframeChildContextListeners[msg].filter(function (listener) {
            return listener.uuid !== __uuid;
          });
        };
      }
    },
    // 发送到总线
    send: function send(msg, payload) {
      if ((0, _detector.is)('iframe') && !_detector.isContainer) {
        handshake.childApi.emit(msg, payload);
      } else {
        var sender = __subscribe(msg, function (p) {
          __postMessage(msg, p);
        });
        sender.send(msg, payload);
      }
    },
    // 跨上下文广播
    broadcast: function broadcast(msg) {
      var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      this.send((0, _detector.is)('iframe') && !_detector.isContainer ? BROADCAST_FROM_IFRAME : BROADCAST_FROM_SAME_CONTEXT, {
        message: msg,
        payload: payload
      });
    }
  };
};

// ensure singleton
if (!window[GLOBAL_CHANNEL_SYMBOL]) {
  window[GLOBAL_CHANNEL_SYMBOL] = Channel();
}
var channel = window[GLOBAL_CHANNEL_SYMBOL];
exports.channel = channel;
channel.debug = function () {
  _postmate.Postmate.debug = true;
};